"use strict";var cof=require("./_cof");module.exports=function(r,e){if("number"!=typeof r&&"Number"!=cof(r))throw TypeError(e);return+r};